// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2NMbS","sendOtp":"AuthorizeToLogin_sendOtp__7tiNw"};